export default function ConfigChecker() {
  return null;
}
